import ChangeHistory from '../ui/sections/ChangeHistory.vue' //only for admin

import Overview from '../ui/sections/Overview.vue'
import Info from '../ui/sections/Info.vue'
import Identity from '../ui/sections/Identity.vue'
import Diploma from '../ui/sections/Diploma.vue'
import SpecialMarks from '../ui/sections/SpecialMarks.vue'
import Exams from '../ui/sections/Exams.vue'
import RatingList from '../ui/sections/RatingList.vue'
import Achievements from '../ui/sections/Achievements.vue'
import Dissertation from '../ui/sections/Dissertation.vue'
import Contract from '../ui/sections/Contract.vue'

import Documents from '../ui/sections/Documents.vue'

export const APPLICATION_SECTIONS = [
  { key: 'change_history', label: 'История изменений', component: ChangeHistory, condition: () => window.gon?.user?.is_admin },
  { key: 'overview', label: 'Обзор', component: Overview },
  { key: 'info', label: 'Личные данные', component: Info },
  { key: 'identity', label: 'Документ, удостоверяющий личность', component: Identity },
  { key: 'diploma', label: 'Образование', component: Diploma },
  { key: 'special_marks', label: 'Отличительные признаки', component: SpecialMarks },
  { key: 'exams', label: 'Вступительные испытания', component: Exams },
  { key: 'rating_list', label: 'Рейтинг-лист направлений подготовки/специальностей', component: RatingList },
  { key: 'achievements', label: 'Индивидуальные достижения', component: Achievements },
  { key: 'dissertation', label: 'Диссертация и научный руководитель', component: Dissertation, condition: (appInstance) => appInstance.isAspirant },
  { key: 'contract', label: 'Договор на оказание платных образовательных услуг', component: Contract },

  { key: 'documents', label: 'Документы', component: Documents },
]

export const APPLICATION_SECTIONS_REGEX = APPLICATION_SECTIONS.map(s => s.key).join('|')
